export const returnString = (arg: any, defaultString = '') => {
	if (typeof arg === 'string') {
		return arg;
	}
	return defaultString;
};
